<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "UnderMaintenance",

  metaInfo: { title: "Under Maintenance" },

  extends: View,

  mixins: [LoadSections(["under-maintenance", "info"])],

  props: {
    id: {
      type: String,
      default: "under-maintenance"
    }
  }
};
</script>
